import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router'
import './styles/global.scss'
import './styles/index.css'
import { router } from './router'
import { router as routerProxy } from '@/provide/NavProvider'
import './i18n' // 初始化 i18n
import { bindMiddleware } from '@/apis/client/middleware'
import { logout } from './store/user/useUserStore'
import { alerts } from './ui/useAlertStore'
import { ROUTES } from './env/routes'
import { ModalState } from './ui/useModal'
import NiceModal from '@ebay/nice-modal-react'
import { toast } from './ui/useToastStore'

bindMiddleware({
  rejected: (error) => {
    const code = String(error?.response?.data?.code)
    const status = String(error?.response?.status)

    /** 帳號在異地登出 */
    if (/^(1004|1005|1002)$/.test(code)) {
      routerProxy?.push?.(ROUTES.LOGIN())

      logout() // 直接登出
      alerts({
        key: String(error?.response?.data?.code),
        message: String(error?.response?.data?.msg || error),
        onClose: ({ close }) => {
          routerProxy?.push?.(ROUTES.LOGIN())
          // 搶登的話，關閉所有 Modal
          Object.keys(ModalState).forEach((key) => NiceModal.hide(key))
          close?.()
        },
      })
    } else if (status === '401') {
      logout() // 直接登出
      toast(error?.response?.data?.msg || '')
      return routerProxy?.push?.(ROUTES.LOGIN())
    }

    return Promise.reject(error)
  },
})

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  // <React.StrictMode>
  <RouterProvider router={router} />,
  // </React.StrictMode>,
)
